/**
 * SlideContentLayer — chooses the right variant renderer for the
 * slide's `type` (TITLE / MESSAGE / PHOTO / MEMORY / QUESTION /
 * FINAL) and applies the legacy `effectEntry` animation hook.
 *
 * This is a thin wrapper: the heavy lifting lives in the variants
 * module (slides/variants) and the entry-effect registry
 * (slides/entry).
 */
import { SlideVariant } from '../slides/variants/SlideVariant';
import type { PreviewSlideData } from '../PreviewSlide';
import { ApplyEntryEffect } from '../slides/entry/ApplyEntryEffect';

export function SlideContentLayer({ slide }: { slide: PreviewSlideData }) {
  return (
    <ApplyEntryEffect code={slide.effectEntry}>
      <SlideVariant slide={slide} />
    </ApplyEntryEffect>
  );
}
